import {
  Carnivore,
  DocumentEvents,
  DOMOverlay,
  Sheet,
  SheetEventHandler,
  SheetEvents,
  SheetLayer,
} from '@bluebeam/carnivore';

export type CarnLibArgs = {
  SheetEvents: typeof SheetEvents;
  DocumentEvents: typeof DocumentEvents;
  SheetEventHandler: typeof SheetEventHandler;
  Sheet: typeof Sheet;
  SheetLayer: typeof SheetLayer;
  Carnivore: typeof Carnivore;
  DOMOverlay: typeof DOMOverlay;
};

class CarnivoreLib {
  SheetEvents: typeof SheetEvents;

  DocumentEvents: typeof DocumentEvents;

  SheetEventHandler: typeof SheetEventHandler;

  Sheet: typeof Sheet;

  SheetLayer: typeof SheetLayer;

  Carnivore: typeof Carnivore;

  DOMOverlay: typeof DOMOverlay;

  constructor(lib: CarnLibArgs) {
    this.SheetEvents = lib.SheetEvents;
    this.DocumentEvents = lib.DocumentEvents;
    this.SheetEventHandler = lib.SheetEventHandler;
    this.Sheet = lib.Sheet;
    this.SheetLayer = lib.SheetLayer;
    this.Carnivore = lib.Carnivore;
    this.DOMOverlay = lib.DOMOverlay;
  }
}

export default CarnivoreLib;

export async function getCarnivoreLibComponent(): Promise<CarnivoreLib> {
  const CarnModule = await import('@bluebeam/carnivore');

  return new CarnivoreLib(CarnModule);
}
